export default "__VITE_ASSET__B4n1vU3q__"